import axios from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function createAbandonment (pFormData) {
    const URI = `${BASE_URL}/api/abandonments`
    return axios.post(URI, pFormData, { headers })
}

function abandonmentChangeToPostponement (pAbandonmentId) {
    const URI = `${BASE_URL}/api/abandonment/${pAbandonmentId}/change-to-postponement`
    return axios.get(URI, { headers })
}

function destroyAbandonment (pAbandonmentId) {
    const URI = `${BASE_URL}/api/abandonments/${pAbandonmentId}`
    return axios.delete(URI, { headers })
}

export {
    createAbandonment,
    abandonmentChangeToPostponement,
    destroyAbandonment
}